// extracted by mini-css-extract-plugin
export default {"loading":"loading__DR+cJ","logo":"logo__3ZRr0","label":"label__j-ud7"};